import React, { useContext, useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';

import { DealRoomContext } from '../../components/context';
import { DealRoomDescription } from '../../components/description';
import MapDeals from 'src/pages/dealRooms/components/create/mapDeals';
import Slider from 'src/components/slider';
import Button from 'src/components/button';
import SmartCardsList from '../../components/smartCards';
import { editDealRoom, fetchDealRoomSmartCards } from 'src/redux/actions/dealRoom';
import styles from './styles.module.scss';
import { StakeHolderTypeEnum } from 'src/types/dealRoom';

const noAssets = "/images/dealRoom/no_assets.svg";
const noUsers = "/images/dealRoom/no_users.svg";

const OverView: React.FC = () => {
  const dispatch = useDispatch();
  const { dealRoom, id, onMenuChange, hasContents, menuState, updateDealRoomProperty, showDealDetails, dealRoomAssets, handleAddAssetClick, handleAddUsersClick } = useContext(DealRoomContext);
  const activatedIntegrations = useSelector((state) => _.get(state, 'legacyRootReducer.settings.integrations.activated.items', []));
  const externalStakeholders = useSelector((state) => _.get(state, `dealRooms.dealRoom[${id}].stakeholders.people.[${StakeHolderTypeEnum.EXTERNAL}`, {}));
  const loading = useSelector((state: any) => _.get(state, `dealRooms.dealRoom['${id}'].loading`, false));
  
  const crmIntegrations = _.filter(activatedIntegrations, (item: any) => {
    return _.get(item, "category.name") === "CRM" && _.get(item, "state.code", "") === "ok";
  });
  const isCRMIntegrated = _.size(crmIntegrations) > 0;

  const [selectedOpportunity, setSelectedOpportunity] = React.useState<string>("");
  const [showMapDeals, setShowMapDeals] = useState(false);

  const isEditing = menuState.primaryAction === 'edit';
  const handleMapDealClick = () => {
    setShowMapDeals(true);
    onMenuChange({ primaryAction: 'edit' });
    dispatch(editDealRoom({
      dealRoom: dealRoom,
      assets: dealRoomAssets
    }));
  }

  useEffect(() => {
    if (dealRoom?.opportunity) {
      setSelectedOpportunity(dealRoom.opportunity);
      dispatch(fetchDealRoomSmartCards({
        dealRoomId: dealRoom?.id!
      }));
    }
  }, [dealRoom]);

  useEffect(() => {
    dispatch(fetchDealRoomSmartCards({
      dealRoomId: dealRoom?.id!
    }))
  }, []);

  const showEmptyState = !_.get(externalStakeholders,"loading",true) && !loading && !hasContents || _.size(_.get(externalStakeholders,"items",[])) === 0;

  return (
    <>
      <div className={styles.overviewContainer}>
        <div className={styles.contentContainer}>
          {(isEditing || _.size(dealRoom?.description) > 0) && (
            <DealRoomDescription
              dealRoom={dealRoom}
              menuState={menuState}
              maxHeight="none"
              onMenuChange={onMenuChange}
              disabled={false}
            />
          )}
          {showEmptyState && (
            <div className={styles.emptyState}>
              <div>
                <img src={noAssets} />
                <p>{ hasContents ? "Assets added - time to invite users!" : "No assets have been added yet!" }</p>
                <Button
                  className={styles.addButton}
                  onClick={handleAddAssetClick}
                  disabled={false}
                  text="Add assets"
                  variant="primary"
                  icon="paperflite-arrow-up"
                />
              </div>
              <div>
                <img src={noUsers} />
                <p>{ hasContents ? "No users have been added yet!" : "Add assets to invite users!"} </p>
                <Button
                  className={styles.addButton}
                  onClick={handleAddUsersClick}
                  disabled={!hasContents}
                  text="Add Users"
                  variant="primary"
                  icon="paperflite-arrow-up"
                />
              </div>
            </div>
          )}
        </div>

        <div className={styles.smartCardsContainer}>
          {!isEditing && (
            <SmartCardsList
              handleMapDealClick={handleMapDealClick}
              showDealDetails={showDealDetails}
            />
          )}
        </div>

        <Slider.Dialog
          width={"25rem"}
          show={showMapDeals}
          onClose={() => setShowMapDeals(false)}
        >
          <Slider.Header className={styles.sliderHeader}>
            <div className={styles.titleContainer}>
              <div className={styles.title}>map deals</div>
              <div className={styles.subTitle}>
                Pick the deal you want emotionally attached to this share.
              </div>
            </div>
          </Slider.Header>

          <Slider.Body className={styles.body}>
            <MapDeals isCRMIntegrated={isCRMIntegrated} setSelectedOpportunity={setSelectedOpportunity} selectedOpportunity={selectedOpportunity} />
          </Slider.Body>

          <Slider.Actions>
            <Button variant="primary" icon='paperflite-tick' text={"Add"} disabled={false} onClick={() => {
              updateDealRoomProperty('opportunity', selectedOpportunity);
              setShowMapDeals(false);
            }}></Button>
            <Button variant="secondary" text="Cancel" disabled={false} onClick={() => setShowMapDeals(false)} ></Button>
          </Slider.Actions>
        </Slider.Dialog>
      </div>
    </>
  )
};

export default OverView;